'use strict';

export default class {
	/*@ngInject*/
	constructor($http, JSONToCSVConvertor){
		this.$http = $http;
		this.states = ['QLD', 'NSW', 'VIC', 'SA', 'WA', 'TAS', 'NT', 'ACT'];
		this.counts = [];
		this.tutors = [];
		this.JSONToCSVConvertor = JSONToCSVConvertor;
		this.loaded = false;
	}

	$onInit(){
		this.$http.get('/api/tutors').then(res => {
			this.tutors = res.data;
			this.states.forEach(state => {
				state = state.toLowerCase();

				var count = this.tutors.filter(tutor => tutor.state.toLowerCase() === state).length;

				if(count){
					this.counts.push({count, state});
				}
				
			})
			this.loaded = true;
		})
	}

	createCSV(){
		this.JSONToCSVConvertor(this.counts, 'Tutor_Count_By_State', true);
	}
}


// WEBPACK FOOTER //
// ./client/app/reports/tutor-count/tutor-count.controller.js